<div class="container-fluid bg-white p-0">
    <!-- Spinner Start -->
    <div id="spinner"
        class="show bg-white position-fixed translate-middle w-100 vh-100 top-50 start-50 d-flex align-items-center justify-content-center">
        <div class="spinner-grow text-primary" style="width: 3rem; height: 3rem" role="status">
            <span class="sr-only">Loading...</span>
        </div>
    </div>
    <!-- Spinner End -->

    <!-- Navbar & Hero Start -->
    <div class="container-xxl position-relative p-0">
        <nav class="navbar navbar-expand-lg navbar-light px-4 px-lg-5 py-3 py-lg-0">
            
            <div class="d-flex justify-content-center align-item-start">
                <a href="" class="navbar-brand p-0">
                    <img src="assets/dataxplode-logo-1.png" alt="Logo" />
                </a>    

                <div class="d-flex flex-column justify-content-end align-item-end">
                    <p class="m-0 p-0"  style="font-weight: 500; font-size:0.8rem;">Sponsored by</p> 
                    <a href="" class="navbar-brand p-0 ">
                        <img style="width: 7rem;" src="assets/pcombinatorlogo.png" alt="Logo" />   
                    </a>
                </div>
      
            </div>
 

            <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarCollapse">
                <span class="fa fa-bars"></span>
            </button>
            <div class="collapse navbar-collapse" id="navbarCollapse">
                <div class="navbar-nav ms-auto py-0">
                    <a href="index.html" class="nav-item nav-link active">Home</a>
                    <!-- <a class="nav-item dropdown">Service</a> -->
                    <div class="nav-item dropdown">
                        <a href="#" class="nav-link dropdown-toggle" data-bs-toggle="dropdown">Service</a>
                        <div class="dropdown-menu m-0">
                            <a href="/" class="dropdown-item">Product Search</a>
                            <a href="/" class="dropdown-item">Keyword Search</a>
                            <a href="/" class="dropdown-item">AI Development</a>
                            <a href="/" class="dropdown-item">Competitor Analysis</a>
                            <a href="/" class="dropdown-item">Automation</a>
                            <a href="/" class="dropdown-item">Data Acquisition</a>
                        </div>
                    </div>
                    <!-- <a href="project.html" class="nav-item nav-link">Project</a> -->
                    <div class="nav-item dropdown">
                        <a href="#" class="nav-link dropdown-toggle" data-bs-toggle="dropdown">Products</a>
                        <div class="dropdown-menu m-0">
                            <a [routerLink]="['/auth/login']" class="dropdown-item">MarketscopePro</a>
                            <a [routerLink]="['/auth/login']" class="dropdown-item">AnnotaLab</a>
                        </div>
                    </div>
                    <a (click)="pricingPage()" class="nav-item nav-link">Pricing</a>
                    <a (click)="topToBottom()" class="nav-item nav-link">Contact</a>
                    <a (click)="aboutUs()" class="nav-item nav-link">About</a>
                </div>
                <button type="button" class="btn text-secondary ms-3" data-bs-toggle="modal" data-bs-target="#searchModal">
                    <i class="fa fa-search"></i>
                </button>
            </div>
        </nav>

        <div class="container-xxl py-5 bg-primary hero-header mb-5">
            <div class="container my-5 py-5 px-lg-5">
                <div class="row g-5 py-5">
                    <div class="col-lg-6 text-center text-lg-start">
                        <h1 class="text-white mb-4 animated zoomIn">
                            Empower your business with actionable insights and strategic
                            intelligence.
                        </h1>
                        <p class="text-white pb-3 animated zoomIn">
                            Maximize your business potential with our Next-Gen AI System.
                            Engineered for startups and manufacturers, it offers real-time
                            insights, and identifies opportunities. Utilize AI-driven analysis
                            and extensive market data to make strategic decisions, understand
                            customer sentiments, and optimize product positioning.
                        </p>
                        <a (click)="checkToken()"
                            class="btn btn-light py-sm-3 px-sm-5 rounded-pill me-3 animated slideInLeft">Login</a>
                        <a href=""
                            class="btn btn-outline-light py-sm-3 px-sm-5 rounded-pill animated slideInRight">Contact
                            Us</a>
                    </div>
                    <div class="col-lg-6 text-center text-lg-start">
                        <img class="img-fluid" src="/assets/img/newsletter.png" alt="" />
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- Navbar & Hero End -->

    <!-- Full Screen Search Start -->
    <div class="modal fade" id="searchModal" tabindex="-1">
        <div class="modal-dialog modal-fullscreen">
            <div class="modal-content" style="background: rgba(29, 29, 39, 0.7)">
                <div class="modal-header border-0">
                    <button type="button" class="btn bg-white btn-close" data-bs-dismiss="modal"
                        aria-label="Close"></button>
                </div>
                <div class="modal-body d-flex align-items-center justify-content-center">
                    <div class="input-group" style="max-width: 600px">
                        <input type="text" class="form-control bg-transparent border-light p-3"
                            placeholder="Type search keyword" />
                        <button class="btn btn-light px-4">
                            <i class="bi bi-search"></i>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- Full Screen Search End -->

    <!-- About Start -->
    <div class="container-xxl py-5">
        <div class="container px-lg-5">
            <div class="row g-5">
                <div class="col-lg-6 wow fadeInUp" data-wow-delay="0.1s">
                    <div class="section-title position-relative mb-4 pb-2">
                        <h6 class="position-relative text-primary ps-4">About Us</h6>
                        <h2 class="mt-2">The best solution for surpassing rivals</h2>
                    </div>
                    <p class="mb-4">
                        At DataXplode, we provide advanced AI solutions that transform
                        decision-making for startups and manufacturers. Our mission is to
                        deliver real-time insights and actionable intelligence to keep you
                        ahead of market trends. Combining innovation with deep industry
                        expertise, our team offers tailored AI tools to uncover
                        opportunities and drive strategic success. We are dedicated to
                        evolving our solutions to help you excel in a competitive landscape.
                        Discover how our cutting-edge technology can elevate your business.
                        Contact us to learn more and explore our innovative solutions.
                    </p>
                    <div class="row g-3">
                        <div class="col-sm-6">
                            <p style="font-size: large; font-weight: bold" class="mb-0">
                                <i class="fa fa-check text-primary me-2"></i>Tailored Solutions
                            </p>
                            <p style="font-size: large; font-weight: bold" class="mb-3">
                                <i class="fa fa-check text-primary me-2"></i>Customer-Centric
                                Approach
                            </p>
                        </div>
                        <div class="col-sm-6">
                            <p class="mb-3" style="font-size: large; font-weight: bold">
                                <i class="fa fa-check text-primary me-2"></i>24/7 Support
                            </p>
                            <p class="mb-0" style="font-size: large; font-weight: bold">
                                <i class="fa fa-check text-primary me-2"></i>Fair Prices
                            </p>
                        </div>
                    </div>
                    <div class="d-flex align-items-center mt-4">
                        <a class="btn btn-primary rounded-pill px-4 me-3" href="">Read More</a>
                        <a class="btn btn-outline-primary btn-square me-3" href=""><i class="fab fa-facebook-f"></i></a>
                        <a class="btn btn-outline-primary btn-square me-3" href=""><i class="fab fa-twitter"></i></a>
                        <a class="btn btn-outline-primary btn-square me-3" href=""><i class="fab fa-instagram"></i></a>
                        <a class="btn btn-outline-primary btn-square" href=""><i class="fab fa-linkedin-in"></i></a>
                    </div>
                </div>
                <div class="col-lg-6">
                    <img class="img-fluid wow zoomIn" data-wow-delay="0.5s" src="/assets/img/about.jpg" />
                </div>
            </div>
        </div>
    </div>
    <!-- About End -->

    <!-- Newsletter Start -->
    <div class="container-xxl bg-primary newsletter my-5 wow fadeInUp" data-wow-delay="0.1s">
        <div class="container px-lg-5">
            <div class="row align-items-center" style="height: 250px">
                <div class="col-12 col-md-6">
                    <h3 class="text-white">Ready to get started</h3>

                    <div class="w-100 mt-3 bg-danger position-relative rounded-pill">
                        <input class="form-control border-0 rounded-pill w-100 ps-4 pe-5" type="text"
                            placeholder="Enter your email" style="height: 48px" />
                        <button type="button"
                            class="btn shadow-none position-absolute top-50 end-0 translate-middle-y me-2">
                            <i class="fa fa-paper-plane text-primary fs-4"></i>
                        </button>
                    </div>
                </div>
                <div class="col-md-6 text-center mb-n5 d-none d-md-block">
                    <img class="img-fluid mt-5" style="height: 250px" src="/assets/img/newsletter.png" />
                </div>
            </div>
        </div>
    </div>
    <!-- Newsletter End -->

    <!-- Service Start -->
    <div class="container-xxl py-5">
        <div class="container px-lg-5">
            <div class="section-title position-relative text-center mb-5 pb-2 wow fadeInUp" data-wow-delay="0.1s">
                <h6 class="position-relative d-inline text-primary ps-4">
                    Grow Your Business Your Ways
                </h6>
                <h2 class="mt-2">What Solutions We Provide</h2>
            </div>
            <div class="row g-4">
                <div class="col-lg-4 col-md-6 wow zoomIn" data-wow-delay="0.1s">
                    <div class="service-item d-flex flex-column justify-content-center text-center rounded">
                        <div class="service-icon flex-shrink-0">
                            <i class="fas fa-search fa-2x"></i>
                            <!-- <i class="fa fa-home fa-2x"></i> -->
                        </div>
                        <h5 class="mb-3">Product Search</h5>
                        <p>
                            Track and monitor your products and competitors across online
                            stores.
                        </p>
                        <a class="btn p-3 mt-4 mx-auto" href="">Read More</a>
                    </div>
                </div>
                <div class="col-lg-4 col-md-6 wow zoomIn" data-wow-delay="0.3s">
                    <div class="service-item d-flex flex-column justify-content-center text-center rounded">
                        <div class="service-icon flex-shrink-0">
                            <i class="fas fa-search fa-2x"></i>
                        </div>
                        <h5 class="mb-3">Keyword Search</h5>
                        <p>Monitor and improve the ranking of your own product listings.</p>
                        <a class="btn p-3 mt-4 mx-auto" href="">Read More</a>
                    </div>
                </div>
                <div class="col-lg-4 col-md-6 wow zoomIn" data-wow-delay="0.6s">
                    <div class="service-item d-flex flex-column justify-content-center text-center rounded">
                        <div class="service-icon flex-shrink-0">
                            <i class="fas fa-brain fa-2x"></i>
                        </div>
                        <h5 class="mb-3">AI Development</h5>
                        <p>AI applications tailored to meet your specific needs.</p>
                        <a class="btn p-3 mt-4 mx-auto" href="">Read More</a>
                    </div>
                </div>
                <div class="col-lg-4 col-md-6 wow zoomIn" data-wow-delay="0.1s">
                    <div class="service-item d-flex flex-column justify-content-center text-center rounded">
                        <div class="service-icon flex-shrink-0">
                            <i class="fa fa-bar-chart fa-2x"></i>
                        </div>
                        <h5 class="mb-3">Competitor Analysis</h5>
                        <p>
                            Analyze competitors’ strategies to gain insights and improve your
                            produuct positioning.
                        </p>
                        <a class="btn p-3 mt-4 mx-auto" href="">Read More</a>
                    </div>
                </div>
                <div class="col-lg-4 col-md-6 wow zoomIn" data-wow-delay="0.3s">
                    <div class="service-item d-flex flex-column justify-content-center text-center rounded">
                        <div class="service-icon flex-shrink-0">
                            <i class="fa fa-cogs fa-2x"></i>
                        </div>
                        <h5 class="mb-3">Automation</h5>
                        <p>
                            Automate your tasks to streamline operations and boost efficiency.
                        </p>
                        <a class="btn p-3 mt-4 mx-auto" href="">Read More</a>
                    </div>
                </div>
                <div class="col-lg-4 col-md-6 wow zoomIn" data-wow-delay="0.6s">
                    <div class="service-item d-flex flex-column justify-content-center text-center rounded">
                        <div class="service-icon flex-shrink-0">
                            <i class="fa fa-database fa-2x"></i>
                        </div>
                        <h5 class="mb-3">Data Acquisition</h5>
                        <p>
                            Specialize in data acquisition through mobile and web scraping.
                        </p>
                        <a class="btn p-3 mt-4 mx-auto" href="">Read More</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- Service End -->

    <!-- Testimonial Start -->
    <!--     <div class="container-xxl bg-primary testimonial py-5 my-5 wow fadeInUp" data-wow-delay="0.1s">
        <div class="container py-5 px-lg-5">
            <div class="owl-carousel testimonial-carousel">
                <div class="testimonial-item bg-transparent border rounded text-white p-4">
                    <i class="fa fa-quote-left fa-2x mb-3"></i>
                    <p>Dolor et eos labore, stet justo sed est sed. Diam sed sed dolor stet amet eirmod eos labore diam</p>
                    <div class="d-flex align-items-center">
                        <img class="img-fluid flex-shrink-0 rounded-circle" src="img/testimonial-1.jpg" style="width: 50px; height: 50px;">
                        <div class="ps-3">
                            <h6 class="text-white mb-1">Client Name</h6>
                            <small>Profession</small>
                        </div>
                    </div>
                </div>
                <div class="testimonial-item bg-transparent border rounded text-white p-4">
                    <i class="fa fa-quote-left fa-2x mb-3"></i>
                    <p>Dolor et eos labore, stet justo sed est sed. Diam sed sed dolor stet amet eirmod eos labore diam</p>
                    <div class="d-flex align-items-center">
                        <img class="img-fluid flex-shrink-0 rounded-circle" src="img/testimonial-2.jpg" style="width: 50px; height: 50px;">
                        <div class="ps-3">
                            <h6 class="text-white mb-1">Client Name</h6>
                            <small>Profession</small>
                        </div>
                    </div>
                </div>
                <div class="testimonial-item bg-transparent border rounded text-white p-4">
                    <i class="fa fa-quote-left fa-2x mb-3"></i>
                    <p>Dolor et eos labore, stet justo sed est sed. Diam sed sed dolor stet amet eirmod eos labore diam</p>
                    <div class="d-flex align-items-center">
                        <img class="img-fluid flex-shrink-0 rounded-circle" src="img/testimonial-3.jpg" style="width: 50px; height: 50px;">
                        <div class="ps-3">
                            <h6 class="text-white mb-1">Client Name</h6>
                            <small>Profession</small>
                        </div>
                    </div>
                </div>
                <div class="testimonial-item bg-transparent border rounded text-white p-4">
                    <i class="fa fa-quote-left fa-2x mb-3"></i>
                    <p>Dolor et eos labore, stet justo sed est sed. Diam sed sed dolor stet amet eirmod eos labore diam</p>
                    <div class="d-flex align-items-center">
                        <img class="img-fluid flex-shrink-0 rounded-circle" src="img/testimonial-4.jpg" style="width: 50px; height: 50px;">
                        <div class="ps-3">
                            <h6 class="text-white mb-1">Client Name</h6>
                            <small>Profession</small>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div> -->
    <!-- Testimonial End -->

    <!-- Team Start -->

    <!-- <div class="container-xxl py-5">
        <div class="container px-lg-5">
            <div class="section-title position-relative text-center mb-5 pb-2 wow fadeInUp" data-wow-delay="0.1s">
                <h6 class="position-relative d-inline text-primary ps-4">Our Team</h6>
                <h2 class="mt-2">Meet Our Team Members</h2>
            </div>
            <div class="row g-4">
                <div class="col-lg-3 col-md-6 wow fadeInUp" data-wow-delay="0.1s">
                    <div class="team-item">
                        <div class="d-flex">
                            <div class="flex-shrink-0 d-flex flex-column align-items-center mt-4 pt-5" style="width: 75px;">
                                <a class="btn btn-square text-primary bg-white my-1" href=""><i class="fab fa-facebook-f"></i></a>
                                <a class="btn btn-square text-primary bg-white my-1" href=""><i class="fab fa-twitter"></i></a>
                                <a class="btn btn-square text-primary bg-white my-1" href=""><i class="fab fa-instagram"></i></a>
                                <a class="btn btn-square text-primary bg-white my-1" href=""><i class="fab fa-linkedin-in"></i></a>
                            </div>
                            <img class=" rounded" width="206px" height="220px"  src="/assets/img/liton.avif" alt="">
                        </div>
                        <div class="px-4 py-3">
                            <h5 class="fw-bold m-1">Liton Nath</h5>
                            <small class="m-1">Founder & CEO</small>
                        </div>
                    </div>
                </div>
                <div class="col-lg-3 col-md-6 wow fadeInUp" data-wow-delay="0.3s">
                    <div class="team-item">
                        <div class="d-flex">
                            <div class="flex-shrink-0 d-flex flex-column align-items-center mt-4 pt-5" style="width: 75px;">
                                <a class="btn btn-square text-primary bg-white my-1" href=""><i class="fab fa-facebook-f"></i></a>
                                <a class="btn btn-square text-primary bg-white my-1" href=""><i class="fab fa-twitter"></i></a>
                                <a class="btn btn-square text-primary bg-white my-1" href=""><i class="fab fa-instagram"></i></a>
                                <a class="btn btn-square text-primary bg-white my-1" href=""><i class="fab fa-linkedin-in"></i></a>
                            </div>
                            <img class=" rounded " width="206px" height="220px" src="/assets/img/dharm.jpg" alt="">
                        </div>
                        <div class="px-4 py-3">
                            <h5 class="fw-bold m-1">Dharamvir Sharma</h5>
                            <small class="m-1">Co-Founder & Head of Analytics </small>
                        </div>
                    </div>
                </div>
                <div class="col-lg-3 col-md-6 wow fadeInUp" data-wow-delay="0.3s">
                    <div class="team-item">
                        <div class="d-flex">
                            <div class="flex-shrink-0 d-flex flex-column align-items-center mt-4 pt-5" style="width: 75px;">
                                <a class="btn btn-square text-primary bg-white my-1" href=""><i class="fab fa-facebook-f"></i></a>
                                <a class="btn btn-square text-primary bg-white my-1" href=""><i class="fab fa-twitter"></i></a>
                                <a class="btn btn-square text-primary bg-white my-1" href=""><i class="fab fa-instagram"></i></a>
                                <a class="btn btn-square text-primary bg-white my-1" href=""><i class="fab fa-linkedin-in"></i></a>
                            </div>
                            <img class=" rounded " width="206px" height="220px" src="/assets/img/PRAKASH.jpg" alt="">
                        </div>
                        <div class="px-4 py-3">
                            <h5 class="fw-bold m-1">Dr. Prakash Sharma</h5>
                            <small class="m-1">Co-Founder & CTO </small>
                        </div>
                    </div>
                </div>
                <div class="col-lg-3 col-md-6 wow fadeInUp" data-wow-delay="0.6s">
                    <div class="team-item">
                        <div class="d-flex">
                            <div class="flex-shrink-0 d-flex flex-column align-items-center mt-4 pt-5" style="width: 75px;">
                                <a class="btn btn-square text-primary bg-white my-1" href=""><i class="fab fa-facebook-f"></i></a>
                                <a class="btn btn-square text-primary bg-white my-1" href=""><i class="fab fa-twitter"></i></a>
                                <a class="btn btn-square text-primary bg-white my-1" href=""><i class="fab fa-instagram"></i></a>
                                <a class="btn btn-square text-primary bg-white my-1" href=""><i class="fab fa-linkedin-in"></i></a>
                            </div>
                            <img class=" rounded" width="206px" height="220px"  src="/assets/img/shrihari.avif" alt="">
                        </div>
                        <div class="px-4 py-3">
                            <h5 class="fw-bold m-1">Shrihari Binwade</h5>
                            <small class="m-1">Site Architect</small>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div> -->
    <!-- Team End -->

    <!-- Sponsored Start -->
    <div class="container-fluid bg-primary newsletter text-light wow fadeIn">

        <!-- //Titile -->
         <div class="m-0 d-flex m-1 p-3 justify-content-center align-items-center">
            <p class="fs-1 m-1 p-2">Sponsored Partnership</p>
         </div>

        <!-- //Meg -->

        <!-- //Patnerd img -->
        <div class="row g-4">
            <div class="col-md-12 grid-item" data-wow-delay="0.6s">
                <div class="m-3 p-3  d-flex justify-content-center align-items-center">
                    <a href="" class="navbar-brand p-0 bg-white ">
                        <img src="assets/pcombinatorlogo.png" alt="Logo" />   
                    </a>
                </div>
            </div>
        </div>
  
    
       



    </div>

    <!-- Footer Start -->
    <div class="container-fluid bg-primary text-light footer mt-5 pt-5 wow fadeIn" #contactSection
        data-wow-delay="0.1s">
        <div class="container py-5 px-lg-5">
            <div class="row g-5">
                <div class="col-md-6 col-lg-3">
                    <h5 class="text-white mb-4">Get In Touch</h5>
                    <p>
                        <i class="fas fa-map-marker-alt me-3"></i>Office #5, Block 1, Lloyds
                        Chambers, Mangalwar Peth, Near Ambedkar Bhavan, Pune – 411011
                    </p>
                    <p><i class="fas fa-phone-alt me-3"></i>+91 8390234456</p>
                    <p><i class="fa fa-envelope me-3"></i>info</p>
                    <div class="d-flex pt-2">
                        <a class="btn btn-outline-light btn-social" href=""><i class="fab fa-twitter"></i></a>
                        <a class="btn btn-outline-light btn-social" href=""><i class="fab fa-facebook-f"></i></a>
                        <a class="btn btn-outline-light btn-social" href=""><i class="fab fa-youtube"></i></a>
                        <a class="btn btn-outline-light btn-social" href=""><i class="fab fa-instagram"></i></a>
                        <a class="btn btn-outline-light btn-social" href=""><i class="fab fa-linkedin-in"></i></a>
                    </div>
                </div>
                <div class="col-md-6 col-lg-3">
                    <h5 class="text-white mb-4">Popular Link</h5>
                    <a class="btn btn-link" href="">About Us</a>
                    <a class="btn btn-link" href="">Contact Us</a>
                    <a class="btn btn-link" href="">Privacy Policy</a>
                    <a class="btn btn-link" href="">Terms & Condition</a>
                    <a class="btn btn-link" href="">Career</a>
                </div>
                <div class="col-md-12 col-lg-6">
                    <h5 class="text-white mb-4">Connect with us</h5>
                    <p>
                        Unveiling Our AI-Powered Competitive Landscape Analysis Solution.
                    </p>
                    <div class="w-100 mt-3 bg-danger position-relative rounded-pill">
                        <input class="form-control border-0 rounded-pill w-100 ps-4 pe-5" type="text"
                            placeholder="Your Email" style="height: 48px" />
                        <button type="button"
                            class="btn shadow-none position-absolute top-50 end-0 translate-middle-y me-2">
                            <i class="fa fa-paper-plane text-primary fs-4"></i>
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <div class="container px-lg-5">
            <div class="copyright">
                <div class="row">
                    <div class="col-md-6 text-center text-md-start mb-3 mb-md-0">
                        &copy; <a class="border-bottom" href="#">DataXplode</a>, All Right
                        Reserved.
                    </div>
                    <div class="col-md-6 text-center text-md-end">
                        <div class="footer-menu">
                            <a href="">Home</a>
                            <a href="">Cookies</a>
                            <a href="">Help</a>
                            <a href="">FQAs</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- Footer End -->

    <!-- Back to Top -->
    <a href="#"
        class="btn btn-lg btn-primary btn-lg-square back-to-top d-flex justify-content-center align-items-center"><i
            class="fa fa-arrow-up"></i></a>
</div>